// Types
import type { ITab } from '~/misc/v-tabs/types';
import type { TMapStreetViewPanoramaOptions } from '~/misc/v-map-street-view-panorama/types';

const GOOGLE_MAP_API_KEY_SYMBOL: unique symbol = Symbol('gmap-api-key');

const STREET_VIEW_MAP_OPTIONS: TMapStreetViewPanoramaOptions = {
  disableDefaultUI: true,
  controlSize: -1,
  zoom: 0,
};

const TABS: ITab[] = [
  { label: 'Property photos', active: true },
  { label: 'Map view' },
  { label: 'Street view' },
];

export { GOOGLE_MAP_API_KEY_SYMBOL, STREET_VIEW_MAP_OPTIONS, TABS };
